import script from "./Timer.vue?vue&type=script&setup=true&lang=ts"
export * from "./Timer.vue?vue&type=script&setup=true&lang=ts"

import "./Timer.vue?vue&type=style&index=0&id=d9cc9fd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.10_vue@3.5.10_typescript@4.5.5__webpack@5.95.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9cc9fd0"]])

export default __exports__